const Filter = () => {
  const body = document.body;
  const page = document.querySelector(".page");
  const opener = document.querySelector(".filter__opener");
  const closer = document.querySelector(".filter__closer");
  const filter = document.querySelector(".filter__filter-wrapper");

  const closeFilter = () => {
    filter.classList.remove("visible");
    body.classList.remove("no-scroll");
    page.classList.remove("overlay");
  }
  
  if (opener) {
    opener.addEventListener("click", () => {
      filter.classList.add("visible");
      body.classList.add("no-scroll");
      page.classList.add("overlay");
    });
  }

  if (closer) {
    closer.addEventListener("click", () => {
      closeFilter();
    })
  }

  if (filter) {
    document.addEventListener("click", (event) => {
      if (!filter.contains(event.target) && event.target !== opener) {
        closeFilter();
      }
    });
  }
}

export default Filter;